import React, { Component } from 'react';
import commonUtil from '../../../../../utils/commonUtil';
// import { calculateCommision } from '../../actions';


const channel = commonUtil.getChannel();
const constChannels = commonUtil.getClientConstForChannel();
export default class VerificationPanel extends Component {
  constructor(props) {
    super(props);
    this.fullName = '';
  }

  render() {
    if (this.props.user && this.props.user.data.result) {
      this.fullName = this.props.user.data.result.firstName + ' ' + this.props.user.data.result.lastName;
    }
    const { submitTransferenceData } = this.props;
    const digitalWalletAccNumber = (this.props.user.data.result.digitalWalletAccNumber !== 'undefined' && this.props.user.data.result.digitalWalletAccNumber != '' && !_.isEmpty(this.props.user.data.result.digitalWalletAccNumber)) ? this.props.user.data.result.digitalWalletAccNumber : submitTransferenceData.walletNumber;
    /* eslint-disable */

    const marginCard = {
      color: '#333333', 
      fontWeight: '400', 
      paddingTop: '4%'
    }

    const verificationForWallet = (
      <React.Fragment>
        {channel === constChannels.WAP ?
          <div className="col-xs-12 wrapInfo">
            <div className="innerHeaderInfo">
            {
                this.props.isEmployee && this.props.isEmployee !== "true" 
                ? <p style={{color: '#333333'}}>Depósito a {submitTransferenceData.walletType}</p>
                : <p style={{color: '#333333'}}>Depósito a Tarjeta Liverpool</p>

              }
            </div>
            <div className="innerInfo closureInfo">
              <p style={{color: '#333333', fontWeight: '400'}}>Nombre</p>
              <p className="focusOption" style={{color: '#333333', fontWeight: '700'}}>
                {submitTransferenceData.walletHolderName ? submitTransferenceData.walletHolderName : submitTransferenceData.walletUserName}
              </p>
              {submitTransferenceData.walletNumber ?
                <React.Fragment>
                  {
                  this.props.isEmployee && this.props.isEmployee === 'true' 
                  ? <p style={marginCard}> Número de Tarjeta Liverpool</p>
                  : <p style={marginCard}> Número de monedero</p>
                  }
                  <p className="focusOption" style={{color: '#333333', fontWeight: '700'}}>
                    {(submitTransferenceData.walletType !== 'undefined' && submitTransferenceData.walletType == 'Monedero Digital' ) ? digitalWalletAccNumber : submitTransferenceData.walletNumber.replaceAll('x', '*')}
                  </p>
                </React.Fragment> : null}
              {submitTransferenceData.accountNumber ? <React.Fragment>
                {
                  this.props.isEmployee && this.props.isEmployee === 'true' 
                  ? <p style={marginCard}> Número de Tarjeta Liverpool</p>
                  : <p style={marginCard}> Número de monedero</p>
                  }               
                <p className="focusOption"  style={{color: '#333333', fontWeight: '700'}}>{submitTransferenceData.accountNumber.replaceAll('X', '*')}</p></React.Fragment> : null}
              <hr />
              <div className="wrapTableData">
                <table className="tableData">
                  <tbody><tr>
                    <td>
                      <p><span style={{color: '#333333', fontWeight: '400'}}>Monto de depósito</span></p>
                    </td>
                    <td>
                      <p><span style={{color: '#333333', fontWeight: '700'}}>{commonUtil.getCurrency(submitTransferenceData.walletOrEmployeeCardAmount)}</span></p>
                    </td>
                  </tr>
                  </tbody>
                </table>
                {submitTransferenceData && +submitTransferenceData.bonusAmount !== 0 || submitTransferenceData && +submitTransferenceData.walletCommissionAmount !== 0 ? <hr /> : null}
                {submitTransferenceData && +submitTransferenceData.bonusAmount !== 0 ?
                  <div className="wrapTableData">
                    <table className="tableData">
                      <tbody>
                        <tr>
                          <td>
                            <p><span style={{color: '#333333', fontWeight: '400'}}>Bono total</span></p>
                          </td>
                          <td>
                            <p><span style={{color: '#333333', fontWeight: '700'}}>{commonUtil.getCurrency(submitTransferenceData.bonusAmount)}</span></p>
                          </td>
                        </tr>
                      </tbody></table>
                  </div> : null}
                {submitTransferenceData && +submitTransferenceData.walletCommissionAmount !== 0 ?
                  <table className="tableData">
                    <tbody>
                      <tr>
                        <td>
                          <p style={{color: '#333333', fontWeight: '400'}}
                          className="infoTableText">-{+submitTransferenceData.commissionValue}% comsión por depósito a {submitTransferenceData.walletType}</p></td>
                        <td><p>
                          <span style={{color: '#333333', fontWeight: '400'}}>-{commonUtil.getCurrency(submitTransferenceData.walletCommissionAmount)}</span>
                        </p>
                        </td>
                      </tr>
                    </tbody> </table> : null}
              </div>
              <hr />
              <div className="wrapTableData">
                <table className="tableData">
                  <tbody>
                    <tr>
                      <td>
                        <p style={{color: '#333333', fontWeight: '400'}}>{this.props.loadFrom === 'verificationForm' ? <span> Total a recibir </span> : <span> Total a recibir </span>}</p>
                      </td>
                      <td>
                        <p><span style={{color: '#333333', fontWeight: '400', fontWeight: 700 }}>{commonUtil.getCurrency(submitTransferenceData.totalAmount_View)}</span></p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          :
          // code for web
          <div className="block-verification" style={{margin: 'auto', width: '100%', paddingBottom: '32px', paddingTop: '3%' }}>
            <div className={this.props.loadFrom === 'verificationForm' ? 'date-verification text-right' : this.props.loadFrom === 'closureConfirmation' ? 'date-verification' : ''} >
              <span style={{color: '#333333', fontSize: '15px'}}>Fecha de operación &nbsp;
              </span>
              <strong>
                {commonUtil.formatDate(submitTransferenceData && submitTransferenceData.transferDate, 'monthName')}
              </strong>
            </div>
            <div className="header vertical-center-left" style={{color: "#333333"}}>
              {
                this.props.isEmployee && this.props.isEmployee !== "true" 
                ? <span>Depósito a {submitTransferenceData.walletType}</span>
                : <span>Depósito a Tarjeta Liverpool</span>
              }   
            </div>
            <div className="content">
              <div className="col-xs-6 generalData">
                <div>
                  <small style={{color: "#333333", fontSize: '14px'}}>Nombre</small>
                  <p style={{color: "#333333", fontSize: '14px', fontWeight: '700'}}>
                    {submitTransferenceData.walletHolderName ? submitTransferenceData.walletHolderName : submitTransferenceData.walletUserName}
                  </p>
                </div>
                {submitTransferenceData.walletNumber ? 
                  <div>
                    {  this.props.isEmployee && this.props.isEmployee === 'true'
                    ? <small style={{color: "#333333", fontSize: '14px'}}>Número de Tarjera Liverpool</small>
                    : <small style={{color: "#333333", fontSize: '14px'}}>Número de monedero</small>
                    }
                  <p style={{color: "#333333", fontSize: '14px', fontWeight: '700'}}> 
                    {
                      (submitTransferenceData.walletType !== 'undefined' && submitTransferenceData.walletType == 'Monedero Digital' ) 
                      ? digitalWalletAccNumber 
                      : submitTransferenceData.walletNumber.replaceAll('x', '*')}
                  </p> 
                  </div> 
                  : null
                }
                {submitTransferenceData.accountNumber ? 
                  <div>
                    {  this.props.isEmployee && this.props.isEmployee === 'true'
                    ? <small style={{color: "#333333", fontSize: '14px'}}>Número de Tarjera Liverpool</small>
                    : <small style={{color: "#333333", fontSize: '14px'}}>Número de monedero</small>
                    }
                  <p style={{color: "#333333", fontSize: '14px', fontWeight: '700'}}>{submitTransferenceData.accountNumber.replaceAll('X', '*')}</p> 
                  </div>
                  : null}
              </div>
              <div className="col-xs-6">
                <div className="row blockDeposit">
                  <div className="col-md-8 col-sm-8">
                    <p className="text-14" style={{color: "#333333", fontSize: '14px'}}>Monto del depósito</p>
                  </div>
                  <div className="col-xs-4 text-right" style={{color: "#333333", fontSize: '14px', fontWeight: 700 }}>{commonUtil.getCurrency(submitTransferenceData.walletOrEmployeeCardAmount)}</div>
                </div>
                {submitTransferenceData && +submitTransferenceData.bonusAmount !== 0 ?
                  <div className="row blockDeposit">
                    <div className="col-md-8 col-sm-8">
                      <p className="text-14" style={{color: "#333333", fontSize: '14px'}}>Bono total</p>
                    </div>
                    <div className="col-md-4 col-sm-4 text-right"><strong>{commonUtil.getCurrency(submitTransferenceData.bonusAmount)}</strong></div>
                  </div> : null}
                {submitTransferenceData && +submitTransferenceData.walletCommissionAmount !== 0 ?
                  <div className="row blockDeposit">
                    <div className="col-xs-8">
                      <p>-{+submitTransferenceData.commissionValue}% comsión por depósito a {submitTransferenceData.walletType}</p>
                    </div>
                    <div className="col-xs-4 text-right" style={{color: "#333333", fontSize: '14px'}}><strong>-{commonUtil.getCurrency(submitTransferenceData.walletCommissionAmount)}</strong></div>
                  </div> : null}
                <div className="row blockDeposit">
                  <div className="col-xs-8">{this.props.loadFrom === 'verificationForm' ? <p style={{color: "#333333", fontSize: '14px'}}> Total a recibir </p> : <p className='text-14'> Total a recibir </p>}</div>
                  <div className="col-xs-4 text-right"><p style={{color: "#333333", fontSize: '14px', fontWeight: 700 }}>{commonUtil.getCurrency(submitTransferenceData.totalAmount_View)}</p></div>
                </div>
              </div>
            </div>
          </div>}
      </React.Fragment>
    );
    const verificationForCombinadoCard = (
      <React.Fragment>
        {channel === constChannels.WAP ?
          <div className="row" >
            <div className="col-xs-12 wrapInfo">
              <div className="innerHeaderInfo">
                <p>Depósito a cuenta bancaria</p>
              </div>
              <div className="innerInfo closureInfo">
                <p>Nombre</p>
                <p className="focusOption">{submitTransferenceData.cardBankUserName}</p>
                <p>Tipo de cuenta / tarjeta</p>
                <p className="focusOption">{submitTransferenceData.paymentType}</p>
                {
                  this.props.isEmployee && this.props.isEmployee === 'true' 
                  ? <p style={marginCard}> Número de Tarjeta Liverpool</p>
                  : <p style={{color: '#333333', fontWeight: '400'}}> Número de monedero</p>
                  }
                <p className="focusOption">{submitTransferenceData.number ? submitTransferenceData.number : submitTransferenceData.cardNumber}</p>
                <hr />
                <div className="wrapTableData">
                  <table className="tableData">
                    <tbody>
                      <tr>
                        <td>
                          <p><span>Monto de depósito</span></p>
                        </td>
                        <td>
                          <p><span>{commonUtil.getCurrency(submitTransferenceData.cardOrBankAmount)}</span></p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  {submitTransferenceData && +submitTransferenceData.commissionAmount !== 0 ?
                    <table className="tableData">
                      <tbody>
                        <tr>
                          <td>
                            <p><span>-{submitTransferenceData.commissionValue_CardBank}% comsión por depósito a {submitTransferenceData.paymentType}</span></p>
                          </td>
                          <td>
                            <p><span>-{commonUtil.getCurrency(submitTransferenceData.commissionAmount)}</span></p>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    : null}
                </div>
                <hr />
                <div className="wrapTableData">
                  <table className="tableData">
                    <tbody>
                      <tr>
                        <td>
                          <p><span>Total recibido</span></p>
                        </td>
                        <td>
                          <p><span>{commonUtil.getCurrency(submitTransferenceData.totalAmount_CardBank_View)}</span></p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div> :
          <div className="block-verification mb20">
            <div className="header vertical-center-left"><span>Depósito a cuenta bancaria</span></div>
            <div className="content">
              <div className="col-xs-6 generalData">
                <div>
                  <small>Nombre</small>
                  <p>{submitTransferenceData.cardBankUserName}</p>
                </div>
                <div>
                  <small>Tipo de cuenta / tarjeta</small>
                  <p>{submitTransferenceData.paymentType}</p>
                </div>
                <div>
                {  this.props.isEmployee && this.props.isEmployee === 'true'
                    ? <small style={{color: "#333333", fontSize: '14px'}}>Número de Tarjera Liverpool</small>
                    : <small style={{color: "#333333", fontSize: '14px'}}>Número de monedero</small>
                    }
                  <p>{submitTransferenceData.number ? submitTransferenceData.number : submitTransferenceData.cardNumber}</p>
                </div>
              </div>
              <div className="col-xs-6">
                <div className="row blockDeposit">
                  <div className="col-md-8 col-sm-8">
                    <p>Monto del depósito</p>
                  </div>
                  <div className="col-xs-4 text-right"><strong>{commonUtil.getCurrency(submitTransferenceData.cardOrBankAmount)}</strong></div>
                </div>
                {submitTransferenceData && +submitTransferenceData.commissionAmount !== 0 ?
                  <div className="row blockDeposit">
                    <div className="col-xs-8">
                      <p>-{submitTransferenceData.commissionValue_CardBank}% comsión por depósito a {submitTransferenceData.paymentType}</p>
                    </div>
                    <div className="col-xs-4 text-right"><strong>-{commonUtil.getCurrency(submitTransferenceData.commissionAmount)}</strong></div>
                  </div> : null}
                <div className="row blockDeposit">
                  <div className="col-xs-8"> {this.props.loadFrom === 'verificationForm' ? <strong> Total a recibir </strong> : <strong> Total a recibir </strong>}</div>
                  <div className="col-xs-4 text-right"><strong>{commonUtil.getCurrency(submitTransferenceData.totalAmount_CardBank_View)}</strong></div>
                </div>
              </div>
            </div>
          </div>}
      </React.Fragment>
    );
    const ClosingGiftPanel = (
      <div>
        {
          this.props.loadFrom === 'verificationForm' ?
            <div>
              <p className="">Detalles del regalo</p>
              <strong className="">nombre del producto</strong>
              <strong className="">No. de remision</strong>
            </div>
            :
            <div className="row mb-10">
              <div className="table-header">
                <p className="table-title nmv">Detalles del regalo</p>
              </div>
              <div className="table-body">
                <div className="row p-5 nmh">
                  <div className="row nmh borde-abajo mb-10 col-xs-12 body-left">
                    <strong className="label-table nmv">nombre del producto</strong>
                  </div>
                  <div className="col-xs-8">
                    <div>
                      <div className="col-xs-12 row-detail">
                        <div className="text-left">
                          <strong className="label-detail">No. de remision</strong>
                        </div>
                        <div className="col-xs-6">
                          <div className="text-left">
                            <strong className="label-detail">Entrega adomicilo: {submitTransferenceData.walletUserName}</strong>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        }
      </div>
    )

    return (
      <React.Fragment>
        {this.props.submitTransferenceData && this.props.submitTransferenceData.cardOrBankAmount > 0 ? verificationForCombinadoCard : null}
        {this.props.submitTransferenceData && this.props.submitTransferenceData.walletType !== undefined && this.props.submitTransferenceData.walletType !== 'undefined' ? verificationForWallet : null}
        {this.props.submitTransferenceData.isClosingGiftEligible && this.props.submitTransferenceData.isClosingGiftEligible.toString() === 'true' ?
          ClosingGiftPanel : null}
      </React.Fragment>
    );
  }
}
